<template>
  <div>
    <div class="content-banner">
      <el-carousel :interval="5000" arrow="never" height="100%" id="carousel">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index" id="carousel-item">
          <img :src="item.image" alt="" />
        </el-carousel-item>
      </el-carousel>
      <!-- <div class="logo-main">
        <img src="../../../../assets/LOGO.png" alt="" />
      </div> -->
      <div class="banner-title">
        <menuList></menuList>
      </div>
    </div>
  </div>
</template>
<script>
import bannerTwo from "../../../../assets/banner2.png";
import bannerOne from "../../../../assets/banner1.png";
import menuList from "../menu-list/menu-list.vue";
export default {
  components: {
    menuList
  },
  data() {
    return {
      bannerList: [
        {
          image: bannerOne
        },
        {
          image: bannerTwo
        },
      ]
    };
  }
};
</script>
<style lang="less">
@import "./banner.less";
</style>



// WEBPACK FOOTER //
// src/views/home/components/banner/banner.vue